import React from "react";
import { Link } from "react-router-dom";


function ValueWardrobe(props) {
  const KeypointsList=props?.getKeypointsList?.map((el,i)=>{
    return <div className="col-md-4" key={i}>
      <div className="valueBox" dangerouslySetInnerHTML={{__html: el.content}}>
      </div>
    </div>
  })
  return(
    <div className="SliderHome position-relative wardrobeHome pb-0">
      <div className="container position-relative container1500">
          <div className="absoluteHeadingRight">
            <h2 data-aos="fade-up" data-aos-duration="1s">{props.heading}</h2>
          </div>
          <img src={props.image?.url} alt={props.image?.alt}></img>
          <div className="row justify-content-center mt-3 mt-lg-0 pt-3 pt-lg-5 mb-4 mb-lg-5">
            <div className="col-md-12">
              <div className="textModule2 Orangeh6" dangerouslySetInnerHTML={{__html: props.content}}></div>
            </div>
          </div>

          <div className="row justify-content-between mbValue">
              {KeypointsList}
          </div>
      </div>
    </div>
  );
}
export default ValueWardrobe;